import { useEffect } from 'react';
import { NavMarker } from 'react-rhumb';
import { moveToPage, redirectToUrl } from 'unsubscribe-ui/utils/common';

/**
 * This is only a empty placeholder component.
 * @returns empty div
 */
import { jsx as _jsx } from "react/jsx-runtime";
export const Placeholder = () => /*#__PURE__*/_jsx("div", {});

/**
 * This component is used for redirecting requests. NavMarker helps to detect complete page load before redirection.
 * @param url - External link for redirect, redirects to backup by default
 * @returns
 */
export const Redirect = ({
  url
}) => {
  useEffect(() => {
    if (url) {
      redirectToUrl(url);
    } else {
      moveToPage('/backup');
    }
  }, [url]);
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "BACKUP_REDIRECT",
    children: /*#__PURE__*/_jsx(Placeholder, {})
  });
};

/**
 * This component is used for Backup page failure
 * @returns
 */
export const BackupFailure = () => /*#__PURE__*/_jsx(NavMarker, {
  name: "BACKUP_LOADED_FAILURE",
  children: /*#__PURE__*/_jsx(Placeholder, {})
});